/******************************************
*  Author : Riccardo Di Dato
*  Created On : Thu Apr 28 2022
*  File : shared.ts
*******************************************/
import { isFunction } from '../TypeChecking/index.js';
export function isAction(t) {
    return isFunction(t);
}
